import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/components/cert-number-modal/装饰-箭头.png")